import { render, staticRenderFns } from "./modal-footer-slot-with-close.mpx?vue&type=template&id=67efdb3a&isComponent&outputPath=components%2Fmodal-footer-slot-with-close0cb21ada%2Findex"
import script from "./modal-footer-slot-with-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-footer-slot-with-close0cb21ada%2Findex"
export * from "./modal-footer-slot-with-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-footer-slot-with-close0cb21ada%2Findex"
import style0 from "./modal-footer-slot-with-close.mpx?vue&type=style&index=0&id=67efdb3a&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_0cb21ada%22%7D&isComponent&outputPath=components%2Fmodal-footer-slot-with-close0cb21ada%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports